import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import { faBookmark, faEdit, faPaperPlane } from '@fortawesome/pro-regular-svg-icons'
import {
  faBookmark as faSolidBookmark,
  faEdit as faSolidEdit,
  faPaperPlane as faSolidPaperPlane,
} from '@fortawesome/pro-solid-svg-icons'

import IconRadioGroup from 'components/IconRadioGroup'
import {
  PARENT_TRIGGER_DESCRIPTIONS,
  STUDENT_TRIGGER_DESCRIPTIONS,
  TRIGGER_VALUES,
} from 'components/SegmentSelector/outreach-message-trigger-constants'

const getOptions = (selectedTrigger, isParent) => {
  const options = [
    {
      title: 'Follow',
      subtitle: isParent ? PARENT_TRIGGER_DESCRIPTIONS.following : STUDENT_TRIGGER_DESCRIPTIONS.following,
      faIcon: selectedTrigger === TRIGGER_VALUES.following ? faSolidBookmark : faBookmark,
      value: TRIGGER_VALUES.following,
      selected: selectedTrigger === TRIGGER_VALUES.following,
    },
    {
      title: 'Applying',
      subtitle: isParent ? PARENT_TRIGGER_DESCRIPTIONS.applying : STUDENT_TRIGGER_DESCRIPTIONS.applying,
      faIcon: selectedTrigger === TRIGGER_VALUES.applying ? faSolidEdit : faEdit,
      value: TRIGGER_VALUES.applying,
      selected: selectedTrigger === TRIGGER_VALUES.applying,
    },
    {
      title: 'Applied',
      subtitle: isParent ? PARENT_TRIGGER_DESCRIPTIONS.applied : STUDENT_TRIGGER_DESCRIPTIONS.applied,
      faIcon: selectedTrigger === TRIGGER_VALUES.applied ? faSolidPaperPlane : faPaperPlane,
      value: TRIGGER_VALUES.applied,
      selected: selectedTrigger === TRIGGER_VALUES.applied,
    },
  ]
  return options
}

const TriggerSelector = ({ trigger = '', isParent = false, onChange }) => {
  const [selectedTrigger, setSelectedTrigger] = useState(trigger)
  return (
    <React.Fragment>
      <Box pb={2}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
        >
          Select automation trigger
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Select an event to trigger your message, delivered within a two-hour timeframe.
        </Typography>
      </Box>
      <IconRadioGroup
        options={getOptions(selectedTrigger, isParent)}
        onSelect={(value) => {
          setSelectedTrigger(value)
          onChange(value)
        }}
      />
    </React.Fragment>
  )
}

TriggerSelector.propTypes = {
  isParent: PropTypes.bool.isRequired,
  trigger: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TriggerSelector
